import { navbarHeight } from "@nova/constants"

const padding = 5
export const maxHeightCalculation = `calc(100vh - 190px - ${navbarHeight}px - ${padding}px)`

//S3Keys

export const getOrthoImageS3Key = ({
    orgId,
    projectId,
    flightId,
    fileId,
}: {
    orgId: string
    projectId: string
    flightId: string
    fileId: string
}) => `public/org/${orgId}/fire/${projectId}/flight/${flightId}/orthomosaic-input/${fileId}`

export const getInfraredImageS3Key = ({
    orgId,
    projectId,
    flightId,
    fileId,
}: {
    orgId: string
    projectId: string
    flightId: string
    fileId: string
}) => `public/org/${orgId}/fire/${projectId}/flight/${flightId}/infrared/original/${fileId}`

export const getIconImageS3Key = ({
    orgId,
    projectId,
    flightId,
    fileId,
}: {
    orgId: string
    projectId: string
    flightId: string
    fileId: string
}) => `public/org/${orgId}/fire/${projectId}/flight/${flightId}/images/${fileId}`
